import styled, { css } from 'styled-components'
import { iconComponent } from 'ui'
import CropScaler from '../types/scaler'

const ScalerIcon = iconComponent('scaler')

export const Icon = styled(ScalerIcon)`
    display: block;
    height: 100%;
    width: 100%;
`

export const Scaler = styled.div<{ type: CropScaler }>`
    height: 20px;
    user-select: none;
    width: 20px;

    ${({ type }) => {
        const cursor = CropScaler.cursor(type)
        const rotation = CropScaler.rotation(type)

        return css`
            cursor: ${cursor};

            ${Icon} {
                transform: rotate(${rotation}deg);
            }
        `
    }}
`
